import React from "react";
import { StyleSheet, Text } from "react-native";

import UnlockUsersFreeTierBaseModal from "../Base/UnlockUsersFreeTierBaseModal";

import UnlockUsersAvatarCard from "./Components/UnlockUsersAvatarCard";
import UnlockUsersBackgroundPhotoCard from "./Components/UnlockUsersBackgroundPhotoCard";

import { themes } from "@/Components/Styling/themeConfigs";
import { Spacings } from "@/styling/spacings";
import {
  FIRST_STAGE_COMPLETION_SCORE,
  getFirstStageCompletionScore,
} from "@/utils/unlockingStage";
import { UserProfile } from "@/schemas/user/profile";
import { UserUnlockingStage } from "@/schemas/user/identity";

const currentTheme = themes.morning;

type Props = {
  userProfile: UserProfile;
  isModalVisible: boolean;
  onRequestClose: () => void;
  onRequestRefresh: () => void;
  isRefreshing: boolean;
};

function UnlockStageOneModal({
  userProfile,
  isModalVisible,
  onRequestClose,
  onRequestRefresh,
  isRefreshing,
}: Props): React.JSX.Element {
  const progressBarInfoComponent: React.JSX.Element = (
    <>
      <Text style={styles.infoText}>
        Complete steps below to unlock more profiles
      </Text>
    </>
  );

  const taskCardsComponent: React.JSX.Element = (
    <>
      <UnlockUsersAvatarCard
        avatar={userProfile.avatar}
        onAction={onRequestClose}
      />
      <UnlockUsersBackgroundPhotoCard
        backgroundPhoto={userProfile.background}
        onAction={onRequestClose}
      />
    </>
  );

  return (
    <UnlockUsersFreeTierBaseModal
      title={`Unlock to See More Profiles`}
      subtitle={"📋 Just two simple tasks to complete!"}
      currentUnlockingStage={UserUnlockingStage.ON_STAGE_ONE}
      progressBarTitle="Progress"
      earnedScore={getFirstStageCompletionScore(userProfile)}
      totalScore={FIRST_STAGE_COMPLETION_SCORE}
      progressBarInfoComponent={progressBarInfoComponent}
      taskCardsComponent={taskCardsComponent}
      isModalVisible={isModalVisible}
      onRequestClose={onRequestClose}
      onRequestRefresh={onRequestRefresh}
      isRefreshing={isRefreshing}
    />
  );
}

const styles = StyleSheet.create({
  infoText: {
    color: "#555",
    fontSize: currentTheme.typography.h3.size.mobile,
    fontWeight: "bold",
    marginBottom: Spacings.s1,
  },
});

export default UnlockStageOneModal;
